<template>
  <v-card>
    <v-container fluid>
      <v-row dense class="text-h5">
        <v-col> {{ facilitator.value }} </v-col>

        <v-spacer />

        <v-col cols="auto">
          <authorization
            permissionKey="configuration_facilitator_conduct"
            can="save"
            v-slot:default="{ authorization }"
          >
            <v-dialog v-model="dialog" max-width="500px" @click:outside="close">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-if="authorization" class="mr-2" v-bind="attrs" v-on="on">
                  eva-edit-outline
                </v-icon>
              </template>

              <v-card>
                <v-card-title>
                  <span class="headline">Editar facilitator</span>
                </v-card-title>

                <v-card-text>
                  <v-container fluid>
                    <v-row dense>
                      <v-col>
                        <v-text-field
                          outlined
                          dense
                          v-model="facilitator.value"
                          v-uppercase
                          label="Valor"
                          :hide-details="!errors.facilitator"
                          :error-messages="errors.facilitator"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">
                    Cancelar
                  </v-btn>

                  <v-btn color="blue darken-1" text @click="save">
                    Salvar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </authorization>

          <authorization
            permissionKey="configuration_facilitator_conduct"
            can="delete"
            v-slot:default="{ authorization }"
          >
            <v-icon v-if="authorization" @click="deleteItem">
              eva-trash-outline
            </v-icon>
          </authorization>
        </v-col>
      </v-row>

      <v-divider />

      <v-row dense>
        <v-col>
          <ConductOtherFacilitatorList
            :facilitators="actionDetails"
            facilitatorType="detail"
            :parentId="this.facilitator.id"
            :refreshList="refreshList"
            :hideSearch="true"
            :showTextArea="true"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
  import ConductOtherFacilitatorList from "@/components/config/conduct/other_facilitator/list.vue";

  export default {
    name: "ConductActionFacilitatorListItem",
    props: {
      facilitators: Array,
      facilitator: Object,
      facilitatorType: String,
      refreshList: Function,
    },
    components: {
      ConductOtherFacilitatorList,
    },
    data() {
      return {
        errors: {},
        dialog: false,
      };
    },
    computed: {
      actionDetails() {
        return this.lodash.filter(
          this.facilitators,
          function(e) {
            return this.lodash.get(e, "parent.id", "") === this.facilitator.id;
          }.bind(this)
        );
      },
    },
    methods: {
      deleteItem() {
        if (confirm("Você realmente deseja deletar esse facilitador?")) {
          this.apolloMutate({
            mutation: require("@/graphql/conduct/delete_conduct_facilitator.gql"),
            variables: {
              conductFacilitatorId: this.facilitator.id,
            },
          }).then(() => {
            this.refreshList();
            this.$store.dispatch("createNotification", {
              message: "Facilitador deletado com sucesso.",
              type: "success",
            });
          });
        }
      },
      close() {
        this.dialog = false;
      },
      save() {
        if (!this.validate()) return;

        this.apolloMutate({
          mutation: require("@/graphql/conduct/save_conduct_facilitator.gql"),
          variables: {
            conductFacilitatorId: this.facilitator.id,
            parentId: "",
            value: this.facilitator.value,
            category: this.facilitatorType,
          },
        }).then(() => {
          this.refreshList();

          this.$store.dispatch("createNotification", {
            message: "Cadastro salvo com sucesso.",
            type: "success",
          });
        });

        this.close();
      },
      validate() {
        const errorMsg = "Esse campo deve ser preenchido.";
        this.errors = {};

        let value = this.facilitator.value;
        if (this.lodash.isEmpty(value?.trim())) {
          this.errors.facilitator = errorMsg;
        }

        if (Object.keys(this.errors).length === 0) {
          return true;
        }

        return false;
      },
    },
  };
</script>

<style lang="scss" scoped></style>
